<template>
    <div v-if="logged" style="margin-right: 20px;">
        <button type="button" class="btn btn-cart d-block" @click="showCartListing"><i class="fa fa-shopping-cart"></i>
            <span class="d-none d-sm-inline-block">Carrinho</span> ({{ getNumItens }})
        </button>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import GalleryAPI from "../api/GalleryAPI";

export default {
    name: "cart-top-button",
    data() {
        return {
            logged: false
        };
    },
    computed: {
        ...mapGetters({
            getNumItens: "getNumItems",
        }),
    },
    mounted() {
        this.isLogged();
    },
    methods: {
        showCartListing() {
            this.$store.dispatch('showCartListing');
        },
        isLogged() {
            let self = this;
            const galleryApi = new GalleryAPI();
            galleryApi.isLogged()
                .then(res => {
                    if (res.status == 200) {
                        self.logged = true;
                    } else {
                        self.logged = false;
                    }
                })
                .catch(err => {
                    self.logged = false;
                });
        }
    },
};
</script>
